'use strict';

require('./popup');

var layer = angular.module('saturn.map.layer', [
  'saturn.map.layer.popup'
]);

var LayerUtil = require('./LayerUtil');

layer.service('sbMapLayerUtil', LayerUtil);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/index.js